import React, { useEffect, useState } from 'react';
import { Loading } from '../../components/loading/loading';
import { faqList } from '../../api/apiHandler';
import { useTranslation } from 'react-i18next';
import '../../i18';
import { useLocation } from 'react-router-dom';

const Faq = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [content, setContent] = useState([]);
    const isBlankLayout = location.pathname === '/app-faq';

    useEffect(() => {
        const fetchFAQ = async () => {
            try {
                setIsLoading(true);
                const response = await faqList();
                setContent(response?.data?.data);
            } catch (error) {
                console.error('Error fetching FAQ:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchFAQ();
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    if (!content) {
        return <div>{t('noContent')}</div>;
    }

    if (isBlankLayout) {
        return (
            <div className="course-single-area pd-bottom-90">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('faq')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                            <h5 className="mb-4 text-center">{t('howToHelp')}</h5>
                            <div className="FAQAccordion">
                                <div className="faq-accordian-box">
                                    <div className="accordion" id="accordionExample">
                                        {content.map((faq, index) => (
                                            <div className="accordion-item" key={faq.id}>
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${index}`}
                                                        aria-expanded={index === 0}
                                                        aria-controls={`collapse${index}`}
                                                    >
                                                        {faq.question}
                                                    </button>
                                                </h2>
                                                <div
                                                    id={`collapse${index}`}
                                                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        {faq.answer}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="PageTitleBox">
                            <h2 className="PageTitleHeading">{t('faq')}</h2>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                        <h5 className="mb-4 text-center">{t('howToHelp')}</h5>
                        <div className="FAQAccordion">
                            <div className="faq-accordian-box">
                                <div className="accordion" id="accordionExample">
                                    {content.map((faq, index) => (
                                        <div className="accordion-item" key={faq.id}>
                                            <h2 className="accordion-header">
                                                <button
                                                    className="accordion-button"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${index}`}
                                                    aria-expanded={index === 0}
                                                    aria-controls={`collapse${index}`}
                                                >
                                                    {faq.question}
                                                </button>
                                            </h2>
                                            <div
                                                id={`collapse${index}`}
                                                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body">
                                                    {faq.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Faq;